import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/components/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalculatorWithCallToAction"] */ "/app/src/components/Calculator.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/FadeIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GridPattern"] */ "/app/src/components/GridPattern.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootLayout"] */ "/app/src/components/RootLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ScrollGrayscale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StylizedImage"] */ "/app/src/components/StylizedImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/images/entwicklung.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/iphone_mockup.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/lukas_meeting.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/morten.png");
